import React, { Component } from 'react'
import { Button } from 'hljd'
import style from '../style.module.less'
import { observer } from 'mobx-react'
import { getObjValue } from '@hlj/hlj-utils'
import Chat from '@common/Chat'
import { Auth } from '@common/Auth'
import { PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID } from '@constant'
import { isStoreAccount } from '@util'

@observer
export default class extends Component {
  render() {
    const { detail, nevigateToCustomer } = this.props.store
    const { lead, order, admin, created_at, remark_record = [] } = detail || {}
    const { name, phone, user_info, user_id } = lead || {}

    return (
      <div className={style.base_info}>
        <div className={style.customer_info}>
          <h3 className={style.title}>客户信息</h3>
          <div className={style.item}>
            <span>客户信息</span>
            <div>
              <span style={{ marginRight: 11 }}>{name}</span>
              {user_id ? (
                <Chat toUserId={user_id} />
              ) : (
                <span style={{ color: '#ccc', cursor: 'pointer' }}>
                  <img
                    src="//qnm.hunliji.com/o_1c08faiqstfncom10eu1dn16ff7.png"
                    style={{ marginRight: 6, verticalAlign: 'text-top' }}
                  />
                  私信用户
                </span>
              )}
            </div>
          </div>
          <div className={style.item}>
            <span>联系方式</span>
            <div style={{ verticalAlign: 'top' }}>
              <p>电话 {phone}</p>
              {getObjValue(user_info, 'phonev2') && (
                <p>电话2 {getObjValue(user_info, 'phonev2')}</p>
              )}
              {getObjValue(user_info, 'winxin') && (
                <p>微信 {getObjValue(user_info, 'winxin')}</p>
              )}
              {getObjValue(user_info, 'qq') && (
                <p>QQ {getObjValue(user_info, 'qq')}</p>
              )}
            </div>
          </div>
          {isStoreAccount() &&
            detail.merchant_customer_id &&
            detail.merchant_customer_id !== '0' && (
              <Button type="primary" onClick={nevigateToCustomer}>
                客户详情
              </Button>
            )}
        </div>
        <div className={style.demand_note}>
          <h3 className={style.title}>需求备注</h3>

          <Auth role={[PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID]}>
            <div className={style.item}>
              <span style={{ marginRight: 44 }}>需求类型</span>
              <div>{getObjValue(order, 'property.name')}</div>
            </div>
          </Auth>

          <div>{getObjValue(order, 'remark')}</div>
          <div className={style.remark_record}>
            {remark_record.map((item, index) => {
              return (
                <div className={style.record} key={index}>
                  <div className={style.record__top}>
                    <p>
                      统筹师：<span>{item.admin_name}</span>
                    </p>

                    <p>{item.created_at}</p>
                  </div>
                  <p>
                    所属店铺：
                    <span>{item.team_name}</span>
                  </p>
                  <div>{item.remark}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div className={style.dispatch_info}>
          <h3 className={style.title}>派单信息</h3>
          <div className={style.item}>
            <span>推荐时间</span>
            <div>{created_at}</div>
          </div>
          <div className={style.item}>
            <span style={{ marginRight: 44 }}>派单员</span>
            <div>{getObjValue(admin, 'nickname')}</div>
          </div>
        </div>
      </div>
    )
  }
}
